import { Wrapper, Button } from "../styles";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { getShippingFee } from "../api/order";
import { useContext, useEffect, useState } from "react";
import { DataContext } from "../DataContext";

const BottomBar = styled.div`
  padding: 10px 20px !important;
  margin-left: 30px !important;
  margin-right: 30px !important;

  @media only screen and (max-width: 991px) {
    flex-direction: column;
    margin: 10px 20px !important;
  }
`;

const SubmitButton = styled(Button)`
  width: fit-content;
  margin: 30px 30px 30px auto;
  padding: 8px 40px;

  @media only screen and (max-width: 991px) {
    margin: 20px auto;
  }
`;

const ReturnProduct = styled.div`
  padding: 30px 30px 0 30px;
`;

export const ReturnReviewTemplate = ({ products, submit, isFirstReturn, salesTax, customerPostalCode, subTotal }) => {
  let totalRefund = 0; // cents
  let totalSalesTaxRefund = 0; // cents

  const { settings } = useContext(DataContext);

  const [shippingRate, setShippingRate] = useState(null); // dollars

  useEffect(() => {
    const fetchData = async () => {
      const { ground } = await getShippingFee(customerPostalCode, settings.companyZipCode);
      setShippingRate(ground.totalBasePrice);
    };

    fetchData();
  }, []);

  const renderProducts = () => {
    return products.map((product) => {
      if (product.returnType === "Refund") {
        const productSalesTax = Math.round((product.productCost / subTotal) * salesTax);

        totalRefund = totalRefund + product.productCost + productSalesTax;
        totalSalesTaxRefund = totalSalesTaxRefund + productSalesTax;
      }

      if (product.returnType === "Keep") return null;

      return (
        <ReturnProduct className="product-row" key={product.itemId}>
          <div className="product-image">
            <picture>
              <source srcSet={product.thumbnail} type="image/avif" />
              <img src={product.thumbnail} width="140" />
            </picture>
          </div>

          <div className="product-block">
            <div className="product-block-row">
              <span className="product-block-label">Return Type</span>
              <strong className="product-block-value">{product.returnType}</strong>
            </div>

            <div className="product-block-row">
              <span className="product-block-label">Product Name</span>
              <strong className="product-block-value">{product.productName}</strong>
            </div>

            <div className="product-block-row">
              <span className="product-block-label">Product Style</span>
              <strong className="product-block-value">{product.design}</strong>
            </div>

            <div className="product-block-row">
              <span className="product-block-label">Original Size</span>
              <strong className="product-block-value">{product.size}</strong>
            </div>

            {product.returnType === "Exchange" && (
              <div className="product-block-row">
                <span className="product-block-label">Exchange Size</span>
                <strong className="product-block-value">{product.sizeExchange}</strong>
              </div>
            )}

            {product.returnType === "Refund" && (
              <div className="product-block-row">
                <span className="product-block-label">Refund Amount</span>
                <strong className="product-block-value">${(product.productCost / 100).toFixed(2)}</strong>
              </div>
            )}
          </div>
        </ReturnProduct>
      );
    });
  };

  if (shippingRate === null) return null;

  const productsHTML = renderProducts();

  const shippingFee = isFirstReturn ? 0 : shippingRate; // dollars
  const refundAmount = totalRefund - shippingFee * 100; // cents

  return (
    <Wrapper className="modal-styles">
      <Modal.Header closeButton>
        <Modal.Title>Review Your Return/Exchange</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="return-review-template-products">{productsHTML}</div>

        {totalSalesTaxRefund > 0 && (
          <BottomBar className="return-bottom-bar sales-tax">
            <div className="refund-text">
              <span className="text">+ Sales Tax Refund</span>
              <span className="amount">${(totalSalesTaxRefund / 100).toFixed(2)}</span>
            </div>
          </BottomBar>
        )}

        {!isFirstReturn && (
          <BottomBar className="return-bottom-bar shipping-fee">
            <div className="refund-text">
              <span className="text">- Shipping Fee</span>
              <span className="amount">${shippingFee.toFixed(2)}</span>
            </div>
          </BottomBar>
        )}

        {totalRefund > 0 && (
          <BottomBar className="return-bottom-bar">
            <div className="refund-text">
              <span className="text">= Total Refund Amount</span>
              <span className="amount">${(refundAmount / 100).toFixed(2)}</span>
            </div>
          </BottomBar>
        )}

        <SubmitButton onClick={() => submit(refundAmount, shippingFee)}>Submit Return</SubmitButton>
      </Modal.Body>
    </Wrapper>
  );
};
